/* ============================================================
   MEGAMENY - hold menyen apen nar musen krysser toppfeltet
   ------------------------------------------------------------
   Temaet lukker megamenyen i samme oyeblikk musepekeren treffer
   noe som ikke ligger inne i <nav class="header__links-primary">.
   Alt annet i toppfeltet lukker den altsa umiddelbart: logoen,
   luften mellom logoen og forste menypunkt, og de 28 pikslene
   mellom hvert menypunkt. Drar man musen pa skra ned mot panelet,
   snubler man i ett av disse feltene og menyen forsvinner.

   Her holder vi igjen: sa lenge pekeren fortsatt er et sted inne
   i headeren, far ikke temaet lukke menyen med en gang. Kommer
   pekeren tilbake til menyen innen 400 ms, blir den staende.
   Gjor den ikke det, lukker vi den selv - pa temaets egen mate,
   slik at resten av oppforselen er uendret.

   Forlater man headeren helt (ut pa siden, opp i toppbanneret
   eller ut av vinduet), lukkes menyen som for, uten forsinkelse.
   Gjelder kun mus og pekeplate. Beroringsskjerm er urort.
   ============================================================ */
(function () {
  'use strict';

  try {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  } catch (e) { return; }

  var NAV = 'nav.header__links-primary';
  var HEADER = '.header, .header__outer-wrapper';
  var GRACE = 400; // ms man har pa seg til a komme tilbake til menyen

  var timer = null;
  var closingOurselves = false;

  function openTrigger() {
    return document.querySelector('[data-meganav-trigger][aria-expanded="true"]');
  }

  function cancelClose() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function closeNow() {
    timer = null;
    var trigger = openTrigger();
    if (!trigger) return;
    // Lukk pa temaets egen mate, slik at all annen opprydding skjer som vanlig.
    closingOurselves = true;
    try {
      trigger.dispatchEvent(new MouseEvent('mouseout', {
        bubbles: true, cancelable: true, view: window, relatedTarget: document.body
      }));
    } catch (e) {}
    closingOurselves = false;
  }

  function onMouseOut(event) {
    try {
      if (closingOurselves) return;          // var egen lukking skal slippe gjennom
      if (!openTrigger()) return;            // ingen meny apen - ikke var sak

      var to = event.relatedTarget;
      if (!to || to.nodeType !== 1) return;  // ut av vinduet: lukk som for
      if (to.closest(NAV)) return;           // fortsatt inne i menyen: temaet lar den sta
      if (!to.closest(HEADER)) return;       // ute av headeren for godt: lukk som for

      // Pekeren er et annet sted i headeren - gi den et oyeblikk til a finne veien inn.
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      cancelClose();
      timer = setTimeout(closeNow, GRACE);
    } catch (e) {}
  }

  function onMouseOver(event) {
    try {
      if (!timer) return;
      var el = event.target;
      if (el && el.nodeType === 1 && el.closest(NAV)) cancelClose();
    } catch (e) {}
  }

  document.addEventListener('mouseout', onMouseOut, true);
  document.addEventListener('mouseover', onMouseOver, true);
})();


// Fix for Recharge subscription app block - notify on variant change
(function() {
  // Get the full variant object from the product JSON
  function getVariantById(variantId) {
    var productJson = document.querySelector('[id^="ProductJson-"]');
    if (productJson) {
      try {
        var product = JSON.parse(productJson.textContent);
        return product.variants.find(function(v) {
          return v.id == variantId;
        });
      } catch(e) {
        console.log('[Recharge Fix] Error parsing product JSON:', e);
      }
    }
    return null;
  }

  function updateRechargeWidget(variantId) {
    console.log('[Recharge Fix] Updating for variant:', variantId);

    var variant = getVariantById(variantId);
    console.log('[Recharge Fix] Found variant:', variant);

    // Method 1: Update variant select and dispatch change event
    var variantSelects = document.querySelectorAll('select[name="id"]');
    variantSelects.forEach(function(select) {
      select.value = variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Method 2: Dispatch Shopify's standard variant change event on document
    if (variant) {
      document.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: variant }
      }));

      // Also try the Shopify theme event format
      document.dispatchEvent(new CustomEvent('shopify:section:variant:change', {
        bubbles: true,
        detail: { variant: variant }
      }));
    }

    // Method 3: Force Recharge widget to re-read the selected variant
    // by triggering events on Recharge-specific elements
    var rcWidgets = document.querySelectorAll('.rc-widget, [class*="recharge"], [class*="rc-"]');
    rcWidgets.forEach(function(widget) {
      // Try to find and click the subscription radio if not selected
      var subscriptionRadio = widget.querySelector('input[type="radio"]:not(:checked)');
      if (subscriptionRadio) {
        // Store current state, click, then restore if needed
      }
    });

    // Method 4: Look for Recharge's JavaScript objects
    if (window.ReCharge) {
      console.log('[Recharge Fix] Found window.ReCharge');
      if (typeof window.ReCharge.Novum !== 'undefined') {
        console.log('[Recharge Fix] Found ReCharge.Novum');
      }
    }

    // Method 5: Trigger change on the product form
    var productForms = document.querySelectorAll('form[action*="/cart/add"]');
    productForms.forEach(function(form) {
      form.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Listen for theme's variant change event
  document.addEventListener('product:variant-change', function(evt) {
    console.log('[Recharge Fix] Received product:variant-change', evt.detail);
    if (evt.detail && evt.detail.variant && evt.detail.variant.id) {
      updateRechargeWidget(evt.detail.variant.id);
      // Also try with a delay
      setTimeout(function() {
        updateRechargeWidget(evt.detail.variant.id);
      }, 300);
    }
  });

  // Also listen for variant button/chip clicks
  document.addEventListener('click', function(e) {
    var variantButton = e.target.closest('.dynamic-variant-button, .product__chip, .product__color-swatch, [data-option-buttons] button');
    if (variantButton) {
      console.log('[Recharge Fix] Variant button clicked');
      setTimeout(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');
        if (variantId) {
          updateRechargeWidget(variantId);
        }
      }, 300);
    }
  }, true);

  // Log available Recharge objects on page load
  window.addEventListener('load', function() {
    console.log('[Recharge Fix] Page loaded. Checking for Recharge objects...');
    console.log('[Recharge Fix] window.ReCharge:', typeof window.ReCharge);
    console.log('[Recharge Fix] window.RCWidget:', typeof window.RCWidget);
    console.log('[Recharge Fix] window.Recharge:', typeof window.Recharge);

    // Find all Recharge-related elements
    var rcElements = document.querySelectorAll('[class*="rc-"], [class*="recharge"]');
    console.log('[Recharge Fix] Found ' + rcElements.length + ' Recharge elements');
  });

  console.log('[Recharge Fix] Initialized for Recharge app block');
})();

$( document ).ready(function() {
  $(".custom_right").click(function(){
    var count = 0;
    $( ".product-thumbnails__items li button" ).each(function( index ) {
      if($(this).hasClass('active') && count == 0){
        count = parseInt($(this).attr('data-index')) + 1;
      }
      if(parseInt(count) >= 2){
        $('.custom_left').removeClass('slide_dis');
      }
      if(count != 0){
        if(parseInt($(this).attr('data-index')) == parseInt(count)){
          $(this).trigger('click');
          if($(this).hasClass('sld_last')){
            $('.custom_right').addClass('slide_dis');
          }  
        }
      }
    });
  });

   $(".custom_left").click(function(){
    var count = 0;
    $($(".product-thumbnails__items li button").get().reverse()).each(function( index ) {
      console.log($(this).attr('data-index'));
      if($(this).hasClass('active') && count == 0){
        count = parseInt($(this).attr('data-index')) - 1;
      }
      if(count != 0){
        if(parseInt($(this).attr('data-index')) == parseInt(count)){
          $(this).trigger('click');
          $('.custom_right').removeClass('slide_dis');
          if($(this).hasClass('sld_first')){
            $('.custom_left').addClass('slide_dis');
          }  
        }
      }
    });
  });

  
});